import { pipe } from 'fp-ts/lib/function';
import * as t from 'io-ts';
import * as Either from 'fp-ts/Either';
import isValidDate from 'date-fns/isValid';
import addDays from 'date-fns/addDays';
import differenceInDays from 'date-fns/differenceInDays';

/**
 * Converts a number of days since the start of Unix epoch to a Date.
 */
export const DateFromUnixDays = new t.Type<Date, number, unknown>(
  'DateFromUnixDays',
  (u): u is Date => u instanceof Date,
  (u, c) => {
    return pipe(
      t.number.validate(u, c),
      Either.map((unixDays) => addDays(new Date(0), unixDays)),
      Either.chain((date) => (isValidDate(date) ? t.success(date) : t.failure(u, c)))
    );
  },
  (date) => differenceInDays(date, new Date(0))
);
